import { ChevronRight } from "lucide-react";
import React from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";

const ProfileEditCard = () => {
  const { user } = useSelector((state) => state.user);

  return (
    <Link
      to="/editProffile"
      className=" flex items-center p-4 rounded-3xl w-full  border-white  border-4  transition  bg-white/50"
    >
      <img
        src={user.profilephotos}
        alt="avatar"
        className="w-16 h-16 rounded-full object-cover"
      />
      <div className="ml-4">
        <p className="text-lg font-semibold">{user.user_name}</p>
        <p className="text-sm font-semibold">{user.email}</p>
        <p className="text-sm text-gray-700">Account details</p>
      </div>
      <div className="ml-auto ">
        <ChevronRight />
      </div>
    </Link>
  );
};

export default ProfileEditCard;
